import { OauthAccessToken } from "./oauth-access-token";

export class OauthToken {
  private readonly _accessToken: OauthAccessToken
  private readonly _refreshToken: string


  constructor(accessToken: string, refreshToken: string) {
    this._accessToken = new OauthAccessToken(accessToken);
    this._refreshToken = refreshToken;
  }

  get accessToken(): OauthAccessToken {
    return this._accessToken;
  }

  get refreshToken(): string {
    return this._refreshToken;
  }
}

